export default __webpack_public_path__ + "static/media/wallet.a4ba884e.svg";